import create from "zustand";
import { devtools } from "zustand/middleware";
import {
  FoundryProviderState,
  FoundryProviderActions,
  foundryProviderState,
} from "./foundryProviderInterfaces";

export const useFoundryProvider = create<
  FoundryProviderState & FoundryProviderActions
>()(
  devtools((set) => ({
    ...foundryProviderState,
    setConnectors: (connectors: string[]) => {
      set((state) => ({ ...state, connectors }));
    },
    setAlgoSignerLedger: (algoSignerLedger: string) => {
      set((state) => ({ ...state, algoSignerLedger }));
    },
  }))
);
